import { Telemetry } from 'app/services/telemetry/Telemetry';

export type TRawMeasurementPayload = {
  activity_id: string | null;
  activity_type: string;
  activity_name: string;
  status: string;
  completed_at: string;
  standalone: boolean;
  alert: unknown;
  unlocks_activity_id?: string | null;
  unlocks_activity_at?: string | null;
  measurement: {
    id: string;
    type: string;
    measured_at: string;
    device_id: string;
    device_model?: string;
    manual_measurement?: boolean;
    [key: string]: unknown;
  };
};

export function validateMeasurementPayload(data: unknown): TRawMeasurementPayload | null {
  const invalid = (reason: string, extra?: object): null => {
    Telemetry.event('net.websocket.payload.invalid', { domain: 'net', reason, ...extra }, 'warning');
    return null;
  };

  if (!data || typeof data !== 'object') return invalid('not_object');
  const d = data as Record<string, unknown>;

  if (typeof d.activity_name !== 'string') return invalid('missing_activity_name');
  if (!d.measurement || typeof d.measurement !== 'object') return invalid('missing_measurement', { activity_name: d.activity_name });

  const m = d.measurement as Record<string, unknown>;
  if (typeof m.id !== 'string') return invalid('missing_measurement_id', { activity_name: d.activity_name });
  if (typeof m.type !== 'string') return invalid('missing_measurement_type', { activity_name: d.activity_name });

  return data as TRawMeasurementPayload;
}
